// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"312":"dfbb62a6","9745":"d38a3947"}[chunkId] + ".chunk.css";
};